export function preparationMessage(message) {
  const text = typeof message === 'string' ? message : '';
  if (['Stop the previous preparation and settle its receipt before changing the script.', 'Another preparation receipt needs recovery before Voicebox can continue.'].includes(text)) return {
    text: 'An earlier audio preparation needs recovery. Try Stop preparation, then Retry preparation in the original room. If that room is unavailable or recovery fails, contact support. You can still choose a saved scene with audio from the library.',
    detail: text,
  };
  return { text, detail: '' };
}
